import useLanguages from "../../../../explorer/hooks/useLanguages";
import { useTranslation } from "../../../../explorer/hooks/useTranslation";

type TLeadTimeComponent = {
    item: any;
    colName: string;
};

const LeadTimeComponent = (props: TLeadTimeComponent) => {
    const { t } = useTranslation();

    const leadTime = (
        props.item as {
            [key: string]: any;
        }
    )[props.colName];

    return <>{`${leadTime} ${t("common.day")}`}</>;
};

export default LeadTimeComponent;
